
import { PayloadAction } from '@reduxjs/toolkit';
import {
  all,
  call,
  delay,
  put,
  select,
  takeEvery,
  takeLatest
} from 'redux-saga/effects';
import {
  EZCheckValidator,
  getStoreNameList,
  GetStoreNameListParams,
  getTranferStatusWorkflow,
  updateTransferArchive,
  getAllTransferList,
  transferDetailsApi,
  licenseDetailsNewApi,
  getEZCheckValidatorHistory,
  inboundTransferActionApi,
  getStoreFilterConfigData,
  resendIinitiationEmailAPI,
  assignTransferDealer,
  getTransferDealerHistory,
  LicenseById,
  sendEmailToCustomerAssignDealer,
  getSourceDescriptionList,
  generateTrasferMasterProof,
  getDealerDocumentDetails,
  getReAssignHistory,
  getReAssignDealerHistory,
  saveTransferFilters,
  getTransferFilters,
  removeTransferFilters,
  getPermissionsTabs,
  savePermissions,
  getEcommerceStatusList,
  onSkipMicroStep,
  getEmailTamplate,
  callAutoCompleteAPI,
  saveTransferFilterCollection,
  deleteTransferFilterCollection
} from '@/api/apis';
import {
  ezCheckInitiateTransfer,
  setEZCheckStatusTransferCreation,
  setIsEZCheckForTransferCreationInProgress,
  setIsEzCheckInCompleted,
  setIsEzCheckInprogress,
  setIsTransferReinitiateAllowed,
  setisTransferCreationAllowed,
  setIsFetchingTransferStatusWorkflow,
  setTransferStatusWorkflow,
  setEZCheckForTransferCreationMessage,
  setIsRefreshingTransferStatus,
  setIsUpdatingTransferForArchive,
  setIsTransferForArchiveUpdated,
  setStoreNames,
  setIsLoadingTransferExcelGeneration,
  setIsTransferDetailsLoading,
  setTtransferDetails,
  setTransferRecieverDetails,
  setTransferSellerDetails,
  setisLoadingTransferOtherDetails,
  callToGetTransferStatusWorkFlow,
  setInboundTransferStatusWorkflow,
  setTransferRecieverEZDetails,
  setTransferSellerEZDetails,
  setIsRefreshingInboundTransferStatus,
  setIsResendingInitiationEmail,
  setIsInboundActionInprogress,
  setIsAssigningTransferDealer,
  setIsAssigningTransferDealerComplete,
  setHistoryPanelData,
  setIsFetchingHistoryPanelData,
  setTransferDealerHistory,
  setIsTransferDealrHistoryLoading,
  setLicenseeDetail,
  setSendEmailToCustomerStatus,
  setSendEmailToCustomerLoading,
  setSourceDescriptions,
  setIsGenerateMasterProofLoading,
  setGenerateMasterProofStatus,
  setDocumentsRequiredDetails,
  setReAssignHistory,
  setReAssignMicroHistory,
  setIsReAssignMicroHistoryLoading,
  setTransferFilterModel,
  setTransferFilterPreferencesLoaded,
  setIsTransferFiltersLoading,
  setIsRemoveTransferFiltersLoading,
  setPermissionsTabList,
  setIsPermissionsLoading,
  setIsPermissionUpdateLoading,
  setEcommerceStatusData,
  setIsDetailsRefresh,
  setIsDealerDetailsLoading,
  setIsMasterProofTimeOut,
  setIsSkipStepLoading,
  setIsSkipStepSuccess,
  setIsGetEmailTemplateLoading,
  setEmailTamplate,
  setValidLicenseRecord,
  setDocumentsRequiredDetailsLoading,
  setAutoCompleteDataResult,
  setTransferFilterCollection,
  setTransferFilterCollectionLoading,
  setTransferFilterSaveSuccess,
  setTransferFilterDeleteSuccessName,
  setSelectedSavedTransferFilter,
  setStoreNameLists,
  setSourceDescriptionLists,
  setEccomerceStatusFilterLists,
  setSellerLicenseKeyLists,
  setIsClearAllFilterClickedOnTransfer,
  // setInboundDealerId,
} from './slice';
import { AxiosError, AxiosResponse, isAxiosError } from 'axios';
import {
  Toastertype,
  TransferStatusWorkflow,
  keyType,
  TransferListResquestParams,
  TransferDetailsType,
  TransferFilterModel
} from '../types';
import {
  ACTION_FAILED_ERROR,
  FILTER_CLEARED_ACTION,
  FILTER_SAVE_ACTION_SUCCESSFUL,
  REASSIGN_FAILED_ERROR,
  transfer48HrsSuggestion,
  transferTips,
  UPDATE_PERMISSION_ACTION_SUCCESSFUL
} from '@/utils/constants';
import moment from 'moment';
import { formatTransferStatusList, exportXLSXFile, TransferFilterModelInitialValue, InitialPermissionsTabList } from '../utils';
import { sanitizeSearchFiltersForTransferModel } from '../transferQueueSavedFilterUiMeta';
import { RootState } from '@/redux/store';
import { ToasterNotification } from '@/toaster/toasterNotification';
import { OutlineToasterNotification } from '@/toaster/successNotification';
import QueueDataSource from '../QueueDataSource';
import { AgGridReact } from 'ag-grid-react';
import Transfer from '@/model/transfer.mjs';
import { getEightDigitLicenseKey } from '@/explore/ffl-detail/utils.mjs';
import License from '@/model/license.mjs';
import Licensee from '@/model/licensee.mjs';
import { setStoreFilterConfig } from '@/storeAdmin/ducks/slice';
import LicenseeBuilder, { FFLGetDealer } from '@/model/builders/ffl-get-transformer.mjs';
import LicenseDetailBuilder from '@/model/builders/ffl-get-license-details.mjs';

function* runEZCheckValidator(action: PayloadAction<any>) {
  try {
    yield put(setIsEzCheckInprogress(true));
    yield call(EZCheckValidator, action.payload);
    yield put(setIsEzCheckInCompleted(true));
  } catch (error) {
    console.log('error', error);
  } finally {
    yield put(setIsEzCheckInprogress(false));
  }
}

function* runEZCheckForTransferCreation(
  action: PayloadAction<ezCheckInitiateTransfer>
) {
  try {
    yield put(setIsEZCheckForTransferCreationInProgress(true));
    yield put(setisTransferCreationAllowed(false));
    yield put(setIsTransferReinitiateAllowed(false));
    const response: AxiosResponse<{ status: string }> = yield call(
      EZCheckValidator,
      { license_key: action.payload.license_key as string }
    );
    if (
      response.data.status &&
      (response.data.status === '0' || response.data.status === '2')
    ) {
      if (action.payload.isReinitiate)
        yield put(setIsTransferReinitiateAllowed(true));
      else yield put(setisTransferCreationAllowed(true));
    }
    yield put(setEZCheckStatusTransferCreation(response.data.status || '1'));
    yield put(setEZCheckForTransferCreationMessage(null));
  } catch (error) {
    const err = error as AxiosError<{ Error: string }>;
    console.log('error', err);
    yield put(
      setEZCheckForTransferCreationMessage(err?.response?.data?.Error as string)
    );
    yield put(setEZCheckStatusTransferCreation('1'));
  } finally {
    yield put(setIsEZCheckForTransferCreationInProgress(false));
  }
}
interface TransferStatusWorkflowResponse {
  out_bound: Array<TransferStatusWorkflow>;
  in_bound: Array<TransferStatusWorkflow>;
}

function* getTransferStatusWorkFlow(
  action: PayloadAction<{ id: string; updateSuggestion: boolean }>
) {
  try {
    yield put(setIsFetchingTransferStatusWorkflow(true));
    yield put(setIsFetchingHistoryPanelData(true));
    const { updateSuggestion, ...rest } = action.payload;
    const response: AxiosResponse<TransferStatusWorkflowResponse> = yield call(
      getTranferStatusWorkflow,
      rest
    );
    const historyPanelData: AxiosResponse<Array<TransferStatusWorkflow>> = yield call(getTranferStatusWorkflow, {
      id: action.payload.id
    });
    yield put(setHistoryPanelData({ transferStatusWorkflow: historyPanelData?.data || [] }));
    if (response.data) {
      if (response.data.out_bound.length > 0)
        yield put(
          setTransferStatusWorkflow(
            formatTransferStatusList(response.data.out_bound)
          )
        );
      if (response.data.in_bound.length > 0)
        yield put(
          setInboundTransferStatusWorkflow(
            formatTransferStatusList(response.data.in_bound)
          )
        );
    }
  } catch (error) {
    console.log('error', error);
  } finally {
    yield put(setIsFetchingTransferStatusWorkflow(false));
    yield put(setIsRefreshingTransferStatus(false));
    yield put(setIsRefreshingInboundTransferStatus(false));
    yield put(setIsFetchingHistoryPanelData(false));
  }
}

function* downloadTransferListExcel(
  action: PayloadAction<React.RefObject<AgGridReact<Transfer>>>
) {
  yield put(setIsLoadingTransferExcelGeneration(true));
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const archiveParams = Boolean(urlParams.get('archive'));
    const filterModels = action.payload.current?.api.getFilterModel() || {};
    const { searchText, ...rest } = filterModels;
    const transferListSource = new QueueDataSource();
    // @ts-ignore
    const filters = transferListSource.mapFilterModel(rest).join();
    // @ts-ignore
    const agents = transferListSource.getAgentFilter(rest);
    const seachFilter =
      searchText && searchText.filter ? { search: searchText.filter } : {};
    // @ts-ignore
    const orderByModel = yield select(
      (rootState: RootState) => rootState.queue.agGridTransferSortModel
    );
    const orderBy = transferListSource.mapSortModel(orderByModel).join();
    const params: TransferListResquestParams = {
      'orderBy[]': orderBy,
      'filter[]': filters,
      ...(archiveParams ? { isArchive: true } : {}),
      ...seachFilter,
      ...agents
    };
    // @ts-ignore
    const response = yield call(getAllTransferList, params);
    // @ts-ignore
    const generatedBy = yield select((rootState: RootState) => rootState.app.userName)
    // @ts-ignore
    const storeData = yield select((state: RootState) => state.queue.StoreNames);
    // @ts-ignore
    const isGlobalAdmin = yield select((state: RootState) => state.app.isGlobalAdmin);
    exportXLSXFile(response, filterModels, generatedBy, archiveParams, storeData, isGlobalAdmin)
  } catch (error) {
    console.log({ Error: String(error) });
  } finally {
    yield put(setIsLoadingTransferExcelGeneration(false));
  }
}

function* callToupdateTransferArchive(
  action: PayloadAction<{ isArchive: boolean; id: string }>
) {
  try {
    yield put(setIsUpdatingTransferForArchive(true));
    const response: AxiosResponse<Array<TransferStatusWorkflow>> = yield call(
      updateTransferArchive,
      { isArchive: action.payload.isArchive },
      action.payload.id
    );
    if (response.status === 200) {
      yield put(setIsTransferForArchiveUpdated(true));
    }
  } catch (error) {
    OutlineToasterNotification(
      Toastertype.error,
      ACTION_FAILED_ERROR,
      () => { },
      ``,
      true
    );
    console.log('error', error);
  } finally {
    yield put(setIsUpdatingTransferForArchive(false));
  }
}

function* getStoreNames(action: PayloadAction<GetStoreNameListParams | Record<string, never>>) {
  try {
    // @ts-ignore
    const response = yield call(getStoreNameList, action.payload);
    const result = [];
    for (let i = 0; i < response.length; i++) {
      result.push({ label: response[i].store_name, value: response[i].store_id })
    }
    yield put(setStoreNames(result));
  } catch (error) {
    console.log("error", error);
  }
}
function* getSourceDescriptions(action: PayloadAction<{}>) {
  try {
    // @ts-ignore
    const response = yield call(getSourceDescriptionList);
    const result = [];
    for (let i = 0; i < response.length; i++) {
      result.push({ label: response[i]?.source_description, value: response[i]?.source_description?.toLowerCase() })
    }
    yield put(setSourceDescriptions(result));
  } catch (error) {
    console.log("error", error);
  }
}

function* getStoreFilterConfig(action: PayloadAction<{}>) {
  try {
    // @ts-ignore
    const response = yield call(getStoreFilterConfigData);
    yield put(setStoreFilterConfig(response));
  } catch (error) {
    console.log("error", error);
  }
}

function* getTransferDetails(action: PayloadAction<{ id: string, isRefresh?: boolean }>) {
  try {
    yield put(setIsDetailsRefresh(action.payload.isRefresh as boolean));
    if (!action.payload.isRefresh) {
      yield put(setIsTransferDetailsLoading(true));
      yield put(setisLoadingTransferOtherDetails(true));
    }

    const response: AxiosResponse<TransferDetailsType> = yield call(
      transferDetailsApi,
      action.payload.id
    );

    yield put(setIsTransferDetailsLoading(false));
    yield put(setTtransferDetails(response?.data || null));
    // @ts-ignore

    // if (response.data && !action.payload.isRefresh) {
    //   const {
    //     sellerDetails,
    //     reciverDetails,
    //   } = yield all({
    //     sellerDetails: call(
    //       licenseDetailsNewApi,
    //       getEightDigitLicenseKey(
    //         response.data.SellerDetails.licenseId
    //       ) as string,
    //       {
    //         include_blacklisted: true,
    //         include_opt_out_dealers: true,
    //         include_expired: true,
    //         include_permanently_closed_dealers: true
    //       }
    //     ),
    //     reciverDetails: call(
    //       licenseDetailsNewApi,
    //       getEightDigitLicenseKey(
    //         response.data.fflMasterDetails.licenseId
    //       ) as string,
    //       {
    //         include_blacklisted: true,
    //         include_opt_out_dealers: true,
    //         include_expired: true,
    //         include_permanently_closed_dealers: true
    //       }
    //     ),
    //   });

    //   const convertedSellerDetails = LicenseDetailBuilder.buildLicenseDetailsForTransfer(sellerDetails);
    //   const convertedRecieverDetails = LicenseDetailBuilder.buildLicenseDetailsForTransfer(reciverDetails);

    //   yield put(setTransferSellerDetails(convertedSellerDetails || null));
    //   yield put(setTransferRecieverDetails(convertedRecieverDetails || null));
    // }
    // if (response.data && action.payload.isRefresh) {
    //   // @ts-ignore
    //   const receiverResponse: any = yield call(
    //     licenseDetailsNewApi,
    //     getEightDigitLicenseKey(
    //       response.data.fflMasterDetails.licenseId
    //     ) as string,
    //     {
    //       include_blacklisted: true,
    //       include_opt_out_dealers: true,
    //       include_expired: true,
    //       include_permanently_closed_dealers: true
    //     }
    //   )
    //   const convertedRecieverDetails = LicenseDetailBuilder.buildLicenseDetailsForTransfer(receiverResponse);
    //   yield put(setTransferRecieverDetails(convertedRecieverDetails || null));
    // }
    yield put(setisLoadingTransferOtherDetails(false));
  } catch (error) {
    console.log('error', error);
  } finally {
    yield put(setIsTransferDetailsLoading(false));
    yield put(setisLoadingTransferOtherDetails(false));
  }
}
function* putInboundTransferAction(
  action: PayloadAction<{ action: string; id: string }>
) {
  try {
    yield put(setIsInboundActionInprogress(true));
    // @ts-ignore
    const response = yield call(
      inboundTransferActionApi,
      { action: action.payload.action },
      action.payload.id
    );
    if (response.status === 204) {
      yield delay(500);
      yield put(setIsRefreshingTransferStatus(true));
      yield put(callToGetTransferStatusWorkFlow({ id: action.payload.id }));
    }
  } catch (error) {
    console.log('error', error);
  }
}

function* resendIinitiationEmail(
  action: PayloadAction<{ transferId: string }>
) {
  try {
    yield put(setIsResendingInitiationEmail(true))
    // @ts-ignore
    yield call(
      resendIinitiationEmailAPI,
      action.payload.transferId
    );
  } catch (error) {
    console.log('error', error);
  } finally {
    yield put(setIsResendingInitiationEmail(false))
  }
}

function* generateMasterProof(action: PayloadAction<{ transferId: string }>) {
  try {
    yield put(setIsGenerateMasterProofLoading(true));
    // @ts-ignore
    const res = yield call(generateTrasferMasterProof, action.payload.transferId);
    // Show toast notification for async processing
    OutlineToasterNotification(
      Toastertype.success,
      'Master proof generation started. Please check back in 2-3 minutes.',
      () => { },
      ``,
      true
    );
    // Keep loader running for 60 seconds then stop
    yield delay(60000);
    yield put(setIsGenerateMasterProofLoading(false));
    yield put(setGenerateMasterProofStatus('success'));
  } catch (error:any) {
    console.log('error !!!', error);
    yield put(setIsGenerateMasterProofLoading(false));
        // Check for timeout errors
        const isTimeout = error?.response?.status === 504 || 
        error?.status === 504 || 
        (error?.code === 'ECONNABORTED' && error?.message?.toLowerCase().includes('timeout'));

    if (isTimeout) {
      yield put(setIsMasterProofTimeOut(true));
    }else{
      yield put(setGenerateMasterProofStatus('failed'));
    }
  }
}

function* assignTransferDealerHandler(
  action: PayloadAction<{ transferId: string, licenseKey: string, reason?: string }>
) {
  try {
    yield put(setIsAssigningTransferDealer(true))
    const { transferId, licenseKey, reason } = action.payload;
    // @ts-ignore
    const response = yield call(
      assignTransferDealer,
      { transferId, licenseKey, reason }
    );
    if (response.status === 200)
      yield put(setIsAssigningTransferDealerComplete(true));
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response && error.response.status === 409)
        OutlineToasterNotification(
          Toastertype.error,
          REASSIGN_FAILED_ERROR,
          () => { },
          ``,
          true
        );
    }
    console.log('error', error);
  } finally {
    yield put(setIsAssigningTransferDealer(false));
  }
}

function* assignTransferLicenseHandler(
  action: PayloadAction<{ licenseKey: string }>
) {
  try {
    yield put(setIsAssigningTransferDealer(true))
    const { licenseKey } = action.payload;
    const first3 = licenseKey.substring(0, 3)
    const last5 = licenseKey.substring(licenseKey.length - 5)
    // @ts-ignore
    const response = yield call(
      LicenseById, first3, last5
    );
    console.log({ response });
    if (response?.id) {
      const payload = {
        id: response.id,
        name: response.name,
        license_key: response.license_key,
        fullLicenseKey: response.fullLicenseKey,
        contact: {
          address: {
            street1: response.contact.address?.street1,
            city: response.contact.address?.city,
            state: response.contact.address?.state,
            zip: response.contact.address?.zip
          },
          mailAddress: {
            street: response.contact.mailAddress?.street,
            city: response.contact.mailAddress?.city,
            state: response.contact.mailAddress?.state,
            zip: response.contact.mailAddress?.zip
          },
          formattedPhoneNumbers: response?.contact?.formattedPhoneNumbers,
          formattedEmails: response?.contact?.formattedEmails
        },
        optOutOptions: response.optOutOptions,
        defaultShippingAddress: response.defaultShippingAddress,
        customAddress: response.customAddress
      } as Licensee;
      yield put(setLicenseeDetail(payload));
    }
  } catch (error) {
    console.log('error', error);
  } finally {
    yield put(setIsAssigningTransferDealer(false));
  }
}

function* getTransferDealerHistoryHandler(
  action: PayloadAction<{ transferId: string, licenseKey: string }>
) {
  try {
    yield put(setIsTransferDealrHistoryLoading(true));
    const { transferId } = action.payload;
    // @ts-ignore
    let response = yield call(
      getTransferDealerHistory,
      { transferId }
    );
    const finalResponse = response.data.map((responseItem: { dealerDetails: FFLGetDealer, ezCheckDetails: { historyList: Array<{ status: string, created_at: string }> } }) => LicenseeBuilder.buildLicensee({ ezCheckDetails: responseItem.ezCheckDetails, ...responseItem.dealerDetails }));
    console.log("response.data", response.data);
    yield put(setTransferDealerHistory(finalResponse));
  } catch (error) {
    console.log('error', error);
  } finally {
    yield put(setIsTransferDealrHistoryLoading(false));
  }
}

function* sendCustomerAssignDealerEmail(
  action: PayloadAction<{ transferId: string }>
) {
  try {
    yield put(setSendEmailToCustomerLoading(true));
    // @ts-ignore
    yield call(
      sendEmailToCustomerAssignDealer,
      action.payload.transferId
    );
  } catch (error) {
    console.log('error', error);
    yield put(setSendEmailToCustomerStatus('failed'))
    yield put(setSendEmailToCustomerLoading(false));
  } finally {
    yield put(setSendEmailToCustomerStatus('success'))
    yield put(setSendEmailToCustomerLoading(false));
  }
}

function* getReAssignDealerMicroData(action: PayloadAction<{} | {}[]>) {
  try {
    yield put(setIsReAssignMicroHistoryLoading(true));
    // Check if payload is array or single item
    const payloads = Array.isArray(action.payload) ? action.payload : [action.payload];
    
    let allResponseData:any[] = [];
    
    // Make API calls for each payload
    for (const payload of payloads) {
      // @ts-ignore
      const response = yield call(getReAssignDealerHistory, payload);
      if (response?.data && response.data && response?.data?.status && response?.data?.status.length > 0) {
        // Accumulate all response data
        allResponseData.push({
          id: payload.reassignmentId,
          data: response?.data?.status,
          reason: response?.data?.meta?.reason
        });
      }
    }

    if (allResponseData.length > 0) {
      yield put(setReAssignMicroHistory(allResponseData));
    } else {
      yield put(setReAssignMicroHistory([]));
    }
    yield put(setIsReAssignMicroHistoryLoading(false));
  } catch (error) {
    console.log("error", error);
    yield put(setIsReAssignMicroHistoryLoading(false));
  }
}
function* updateTransferDetails(action: PayloadAction<any>) {
  try {
    yield put(setIsTransferFiltersLoading(true))
    const response: AxiosResponse<any> = yield call(saveTransferFilters, action.payload);
    if (response.status === 204) {
      OutlineToasterNotification(
        Toastertype.success,
        FILTER_SAVE_ACTION_SUCCESSFUL,
        () => { },
        ``,
        true
      );
      yield put(setIsTransferFiltersLoading(false))
    }
  } catch (error) {
    yield put(setIsTransferFiltersLoading(false))
    OutlineToasterNotification(
      Toastertype.error,
      'Failed to Save Filters',
      () => { },
      ``,
      true
    );
    console.log('error', error);
  }
}
function* removeTransferFiltersFunction() {
  try {
    yield put(setIsRemoveTransferFiltersLoading(true))
    const response: AxiosResponse<any> = yield call(removeTransferFilters);
    if (response?.status === 204) {
      OutlineToasterNotification(
        Toastertype.success,
        FILTER_CLEARED_ACTION,
        () => { },
        ``,
        true
      );
    }
    yield put(setIsRemoveTransferFiltersLoading(false))
    yield put(setTransferFilterModel(TransferFilterModelInitialValue))
  } catch (error) {
    yield put(setTransferFilterModel(TransferFilterModelInitialValue))
    yield put(setIsRemoveTransferFiltersLoading(false))
    console.log('error while removing filters', error);
  }

}
function* getAppliedTransferFilters() {
  try {
    const response: AxiosResponse<any> = yield call(getTransferFilters);
    if (response?.status === 200 && response?.data.collections?.length > 0) {
      const collections = response?.data?.collections ?? [];
      yield put(setTransferFilterCollection(collections))

      const selectedSavedTransferFilter: {
        value: string;
        label: string;
      } | null = yield select(
        (state: RootState) => state.queue.selectedSavedTransferFilter
      );

      const selectedCollection = selectedSavedTransferFilter
        ? collections.find(
            (collection: any) =>
              String(collection?.id) === String(selectedSavedTransferFilter.value)
          )
        : null;

      const defaultCollection = collections.find(
        (collection: any) => collection?.is_default === true
      );

      const skipDefaultCollection: boolean = yield select(
        (state: RootState) => state.queue.skipDefaultTransferQueueFilterAutoApply
      );
      const collectionToApply =
        selectedCollection ?? (skipDefaultCollection ? null : defaultCollection ?? null);

      if (!selectedSavedTransferFilter && defaultCollection && !skipDefaultCollection) {
        yield put(
          setSelectedSavedTransferFilter({
            value: String(defaultCollection.id),
            label: defaultCollection.name
          })
        );
      }

      if (
        collectionToApply?.search_filters &&
        typeof collectionToApply.search_filters === 'object'
      ) {
        const { model, sellerSelections } = sanitizeSearchFiltersForTransferModel(
          collectionToApply.search_filters as Record<string, unknown>
        );
        yield put(setTransferFilterModel(model));
        yield put(setSellerLicenseKeyLists(sellerSelections));
      }
    }
    yield put(setTransferFilterPreferencesLoaded(true));
  } catch (error) {
    console.log('Error fetching transfer filters', error)
    // Keep current filters/selection on transient fetch failures.
  }
}
function* getPermissionsList() {
  try {

    yield put(setIsPermissionsLoading(true));
    const response: AxiosResponse<any> = yield call(getPermissionsTabs);
    if (response?.status === 200 && Object.keys(response?.data).length > 0) {
      yield put(setPermissionsTabList(response?.data?.permission))
      // yield put(setInboundDealerId(response?.data?.dealerId))
    }
    yield put(setIsPermissionsLoading(false));
  } catch (error: any) {
    console.log('Error saving permissions !!!!!!!!', error)
    yield put(setPermissionsTabList(InitialPermissionsTabList));
    yield put(setIsPermissionsLoading(false));
  }
}
function* updatePermissions(action: PayloadAction<any>) {
  try {
    yield put(setIsPermissionUpdateLoading(true))
    const response: AxiosResponse<any> = yield call(savePermissions, action.payload);
    if (response.status === 200) {
      yield put(setPermissionsTabList(action.payload))
      OutlineToasterNotification(
        Toastertype.success,
        UPDATE_PERMISSION_ACTION_SUCCESSFUL,
        () => { },
        ``,
        true
      );
      yield put(setIsPermissionUpdateLoading(false))
    }
  } catch (error: any) {
    yield put(setIsPermissionUpdateLoading(false))
    OutlineToasterNotification(
      Toastertype.error,
      error?.response?.data?.Error ? error?.response?.data?.Error : 'Failed to Save Permissions',
      () => { },
      ``,
      true
    );
    console.log('error !!!!!!', error.response?.data?.Error);
  }
}
function* onGetReAssignDealerHistory(action: PayloadAction<any>) {
  try {
    const reAssignResponse: AxiosResponse<any> = yield call(
      getReAssignHistory,
      action.payload.id
    );
    if (reAssignResponse?.data && reAssignResponse?.data.length > 0) {
      yield put(setReAssignHistory(reAssignResponse?.data || []));
    } else {
      yield put(setReAssignHistory([]));
    }
  } catch (error) {
    console.log('Error fetching reassign dealer history', error)
    yield put(setReAssignHistory([]));
  }
}
function* onGetDocumentStatus(action: PayloadAction<any>) {
  try {
    yield put(setDocumentsRequiredDetailsLoading(true));
    const payload = {
      licenseKey: getEightDigitLicenseKey(action.payload.id),
      transferId: action.payload.transferId,
    }
    const docResponse: AxiosResponse<any> = yield call(
      getDealerDocumentDetails,
      payload
    );
    if (docResponse) {
      yield put(setDocumentsRequiredDetails(docResponse || {}));
      yield put(setDocumentsRequiredDetailsLoading(false));
    }
  } catch (error) {
    console.log('Error fetching document status', error)
    yield put(setDocumentsRequiredDetails({}));
    yield put(setDocumentsRequiredDetailsLoading(false));
  }
}

function* getECommerceStatus(action: PayloadAction<{}>) {
  try {
    // @ts-ignore
    const response = yield call(getEcommerceStatusList);

    const result = [];
    for (let i = 0; i < response.length; i++) {
      if (response[i]?.ecommerce_status && response[i]?.ecommerce_status !== null && response[i]?.ecommerce_status !== '') {
        result.push({ label: response[i]?.ecommerce_status, value: response[i]?.ecommerce_status?.toLowerCase() })
      }
    }
    yield put(setEcommerceStatusData(result));
  } catch (error) {
    console.log("error", error);
  }
}

function* getAutoCompleteApiResult(action: PayloadAction<{}>){
  try{
    const response :AxiosResponse<any> = yield call(callAutoCompleteAPI, action.payload)
    const data = response?.data?.suggestions
    let finalData: {
      dealerId: string;
      businessName: string;
      licenseName: string;
      shortLicenseNumber: string;
      shortLicenseNumberWithHyphen: string
      city: string,
      state: string
    }[] = [];
    data.forEach((obj: any) => {
      finalData.push({dealerId: obj.dealerId, businessName: obj.businessName, licenseName: obj.licenseName, shortLicenseNumber: obj.shortLicenseNumber, shortLicenseNumberWithHyphen: obj.shortLicenseNumberWithHyphen, city: obj.city, state: obj.state})
    })
    yield put(setAutoCompleteDataResult(finalData));

    // need to setdata
  }catch(err){
    console.log("error", err);
  }
}

function* onGetSellerDetails(action: PayloadAction<any>) {
  try {
    // response.data.SellerDetails.licenseId
    yield put(setIsDealerDetailsLoading(true));
    const response: AxiosResponse<any> = yield call(
      licenseDetailsNewApi,
      getEightDigitLicenseKey(
        action.payload.id
      ) as string,
      {
        include_blacklisted: true,
        include_opt_out_dealers: true,
        include_expired: true,
        include_permanently_closed_dealers: true
      }
    );
    if (response) {
      const convertedSellerDetails = LicenseDetailBuilder.buildLicenseDetailsForTransfer(response as any);
      yield put(setTransferSellerDetails(convertedSellerDetails || null));
    }
    yield put(setIsDealerDetailsLoading(false));
  } catch (error) {
    console.log('Error fetching seller data', error)
    yield put(setTransferSellerDetails(null));
    yield put(setIsDealerDetailsLoading(false));
  }
}

function* onGetRecieverDetails(action: PayloadAction<any>) {
  try {
    // response.data.fflMasterDetails.licenseId
    yield put(setIsDealerDetailsLoading(true));
    const response: AxiosResponse<any> = yield call(
      licenseDetailsNewApi,
      getEightDigitLicenseKey(
        action.payload.id
      ) as string,
      {
        include_blacklisted: true,
        include_opt_out_dealers: true,
        include_expired: true,
        include_permanently_closed_dealers: true
      }
    );
    if (response) {
      const convertedRecieverDetails = LicenseDetailBuilder.buildLicenseDetailsForTransfer(response as any);
      yield put(setTransferRecieverDetails(convertedRecieverDetails || null));
    }
    yield put(setIsDealerDetailsLoading(false));
  } catch (error) {
    console.log('Error fetching reciever data', error)
    yield put(setTransferRecieverDetails(null));
    yield put(setIsDealerDetailsLoading(false));
  }
}

function* onSkipStep(action: PayloadAction<{ transferId: string }>) {
  try {
    yield put(setIsSkipStepLoading(true));
    // @ts-ignore
    const res = yield call(onSkipMicroStep, action.payload.transferId);
    if(res && res.status === 204){
      yield put(setIsSkipStepSuccess(true));
    }
    yield put(setIsSkipStepLoading(false));
  } catch (error:any) {
    console.log('Skip step error !!!', error);
    yield put(setIsSkipStepLoading(false));
    yield put(setIsSkipStepSuccess(false));
  }
}
function* callToGetEmailTemplate(action: PayloadAction<{emailId: string}>) {
  try {
    yield put(setIsGetEmailTemplateLoading(true));
    // @ts-ignore
    const response = yield call(getEmailTamplate, action.payload);
    if (response?.data?.success) {
      yield put(setEmailTamplate(response?.data));
    } else {
      yield put(setEmailTamplate(null));
    }
    yield put(setIsGetEmailTemplateLoading(false));
  } catch (error) {
    console.log("error", error);
    yield put(setIsGetEmailTemplateLoading(false));
  }
}


function* onGetValidLicenseStatus(action: PayloadAction<any>) {
  try {
    yield put(setIsDealerDetailsLoading(true));
    const searchedLicenseKey = getEightDigitLicenseKey(action.payload.id) as string;
    // @ts-ignore
    const licenseRecordResp : any = yield call(
      licenseDetailsNewApi,
      searchedLicenseKey,
      {
        include_blacklisted: true,
        include_opt_out_dealers: true,
        include_expired: true,
        include_permanently_closed_dealers: true
      }
    );
    
    if (licenseRecordResp && Object.keys(licenseRecordResp)?.length) {
      const matchingLicense = licenseRecordResp?.licenses?.find((license: any) => {
        return license.licenseKey === searchedLicenseKey; 
      });
      yield put(setValidLicenseRecord({fullLicenseKeys: matchingLicense?.fullLicenseKey  ? [matchingLicense?.fullLicenseKey] : [],
        licenseKey: matchingLicense?.licenseKey || null,
        dealerId: licenseRecordResp?.dealerId || null,
        recordNotFound: false
      }));
    }
    else{
     yield put(setValidLicenseRecord({recordNotFound: true}));
    }
    yield put(setIsDealerDetailsLoading(false));
  } catch (error) {
    console.log('Error fetching document status', error)
    yield put(setValidLicenseRecord({recordNotFound: true}));
    yield put(setIsDealerDetailsLoading(false));
  }
}

function getSaveTransferFilterCollectionErrorMessage(error: unknown): string {
  const fallback = 'Failed to Save Filters';
  if (!isAxiosError(error)) {
    return fallback;
  }
  if (error.response?.status !== 400) {
    return fallback;
  }
  const data = error.response?.data;
  if (data == null || typeof data !== 'object') {
    return fallback;
  }
  const record = data as Record<string, unknown>;
  const apiErr = record.Error ?? record.error;
  if (typeof apiErr === 'string' && apiErr.trim()) {
    return apiErr.trim();
  }
  if (apiErr != null && typeof apiErr !== 'string') {
    try {
      return JSON.stringify(apiErr);
    } catch {
      return fallback;
    }
  }
  const msg = record.message;
  if (typeof msg === 'string' && msg.trim()) {
    return msg.trim();
  }
  return fallback;
}

function* getTransferFilterCollection() {
  try {
    const response: AxiosResponse<any> = yield call(getTransferFilters);
    if (response?.status === 200) {
      const collections = response?.data?.collections ?? [];
      yield put(
        setTransferFilterCollection(collections)
      );

      const selectedSavedTransferFilter: {
        value: string;
        label: string;
      } | null = yield select(
        (state: RootState) => state.queue.selectedSavedTransferFilter
      );

      const selectedCollection = selectedSavedTransferFilter
        ? collections.find(
            (collection: any) =>
              String(collection?.id) === String(selectedSavedTransferFilter.value)
          )
        : null;

      const defaultCollection = collections.find(
        (collection: any) => collection?.is_default === true
      );

      const skipDefaultCollection: boolean = yield select(
        (state: RootState) => state.queue.skipDefaultTransferQueueFilterAutoApply
      );
      const collectionToApply =
        selectedCollection ?? (skipDefaultCollection ? null : defaultCollection ?? null);

      if (!selectedSavedTransferFilter && defaultCollection && !skipDefaultCollection) {
        yield put(
          setSelectedSavedTransferFilter({
            value: String(defaultCollection.id),
            label: defaultCollection.name
          })
        );
      }

      if (
        collectionToApply?.search_filters &&
        typeof collectionToApply.search_filters === 'object'
      ) {
        const { model, sellerSelections } = sanitizeSearchFiltersForTransferModel(
          collectionToApply.search_filters as Record<string, unknown>
        );
        yield put(setTransferFilterModel(model));
        yield put(setSellerLicenseKeyLists(sellerSelections));
      }
    }
  } catch (error) {
    console.log('Error fetching transfer filters', error);
    // Keep current filters/selection on transient fetch failures.
  }
}


function* onSaveTransferFilterCollection(action: PayloadAction<any>) {
  try {
    yield put(setTransferFilterCollectionLoading(true));
    const response: AxiosResponse<any> = yield call(
      saveTransferFilterCollection,
      action.payload
    );
    if (
      response.status === 204 ||
      response.status === 200 ||
      response.status === 201
    ) {
      const savedName =
        action.payload?.name ?? action.payload?.filterName ?? '';
      yield put(setTransferFilterDeleteSuccessName(null));
      const isUpdate = Boolean(action.payload?.id);
      yield put(
        setTransferFilterSaveSuccess({ name: savedName, isUpdate })
      );
      try {
        const refreshResp: AxiosResponse<any> = yield call(getTransferFilters);
        if (refreshResp?.status === 200) {
          yield put(
            setTransferFilterCollection(refreshResp?.data?.collections ?? [])
          );
        }
      } catch (refreshError) {
        console.log('Error refreshing transfer filter collections', refreshError);
      }
    }
  } catch (error) {
    const toastMessage = getSaveTransferFilterCollectionErrorMessage(error);
    OutlineToasterNotification(
      Toastertype.error,
      toastMessage,
      () => {},
      ``,
      true
    );
    console.log('error', error);
  } finally {
    yield put(setTransferFilterCollectionLoading(false));
  }
}

function* watchCallToSaveTransferFilterCollection() {
  yield takeEvery('queue/callToSaveTransferFilterCollection', onSaveTransferFilterCollection);
}

function* onDeleteTransferFilterCollection(
  action: PayloadAction<{ id: string; name: string }>
) {
  try {
    yield put(setTransferFilterCollectionLoading(true));
    const { id, name } = action.payload;
    const response: AxiosResponse<any> = yield call(
      deleteTransferFilterCollection,
      id
    );
    if (
      response.status === 204 ||
      response.status === 200
    ) {
      yield put(setTransferFilterSaveSuccess(null));
      yield put(setIsClearAllFilterClickedOnTransfer(true));
      yield put(setSelectedSavedTransferFilter(null));
      yield put(
        setTransferFilterModel(TransferFilterModelInitialValue as TransferFilterModel)
      );
      yield put(setStoreNameLists([]));
      yield put(setSourceDescriptionLists([]));
      yield put(setEccomerceStatusFilterLists([]));
      yield put(setSellerLicenseKeyLists([]));
      yield put(setTransferFilterDeleteSuccessName(name));
      try {
        const refreshResp: AxiosResponse<any> = yield call(getTransferFilters);
        if (refreshResp?.status === 200) {
          const deletedId = String(id);
          const refreshedCollections = (refreshResp?.data?.collections ?? []).filter(
            (collection: any) => String(collection?.id) !== deletedId
          );
          yield put(
            setTransferFilterCollection(refreshedCollections)
          );
        }
      } catch (refreshError) {
        console.log(
          'Error refreshing transfer filter collections after delete',
          refreshError
        );
        // Keep UI options in sync even if refresh endpoint is stale/fails.
        const existingCollections: any[] = yield select(
          (state: RootState) => state.queue.transferFilterCollection
        );
        yield put(
          setTransferFilterCollection(
            (existingCollections ?? []).filter(
              (collection: any) => String(collection?.id) !== String(id)
            )
          )
        );
      }
    }
  } catch (error) {
    OutlineToasterNotification(
      Toastertype.error,
      'Failed to delete filter',
      () => {},
      ``,
      true
    );
    console.log('error deleting transfer filter collection', error);
  } finally {
    yield put(setTransferFilterCollectionLoading(false));
  }
}

function* watchCallToDeleteTransferFilterCollection() {
  yield takeEvery(
    'queue/callToDeleteTransferFilterCollection',
    onDeleteTransferFilterCollection
  );
}

function* watchCallToGetTransferFilterCollection() {
  yield takeEvery('queue/callToGetTransferFilterCollection', getTransferFilterCollection);
}

function* watchCallToGetSellerDetails() {
  yield takeEvery('queue/callToGetSellerDetails', onGetSellerDetails);
}
function* watchCallToGetRecieverDetails() {
  yield takeEvery('queue/callToGetRecieverDetails', onGetRecieverDetails);
}
function* watchCallToEZCheckValidator() {
  yield takeEvery('queue/callToEZCheckValidator', runEZCheckValidator);
}

function* watchcallToEZCheckForTransferCreation() {
  yield takeEvery(
    'queue/callToEZCheckForTransferCreation',
    runEZCheckForTransferCreation
  );
}

function* watchcallToGetTransferStatusWorkFlow() {
  yield takeEvery(
    'queue/callToGetTransferStatusWorkFlow',
    getTransferStatusWorkFlow
  );
}

function* watchcallToDownloadTransferList() {
  yield takeEvery(
    'queue/downloadTransferListForExcel',
    downloadTransferListExcel
  );
}
function* watchcallToGetStoreNames() {
  yield takeEvery('queue/callToGetStoreNames', getStoreNames);
}
function* watchcallToGetSourceDescriptions() {
  yield takeEvery('queue/callToGetSourceDescriptions', getSourceDescriptions);
}
function* watchcallToGetStoreFilterConfigData() {
  yield takeEvery("queue/callToGetStoreFilterConfigData", getStoreFilterConfig);
}

function* watchCallToupdateTransferArchive() {
  yield takeEvery(
    'queue/callToUpdateTransferArchive',
    callToupdateTransferArchive
  );
}

function* watchCallInBoundTransferAction() {
  yield takeEvery('queue/callInBoundTransferAction', putInboundTransferAction);
}

function* watchCallToGetTransferDetails() {
  yield takeEvery('queue/callToGetTransferDetails', getTransferDetails);
}

function* watchCallToResendIinitiationEmail() {
  yield takeEvery('queue/callToResendIinitiationEmail', resendIinitiationEmail);
}

function* watchCallToGenerateMasterProof() {
  yield takeEvery('queue/callToGenerateMasterProof', generateMasterProof);
}

function* watchCallToAssignTransferDealerHandler() {
  yield takeEvery('queue/callToAssignTransferDealer', assignTransferDealerHandler);
}
function* watchCallToAssignTransferLicenseHandler() {
  yield takeEvery('queue/callToAssignTransferLicense', assignTransferLicenseHandler);
}
function* watchcallToGetTransferDealerHistory() {
  yield takeEvery("queue/callToGetTransferDealerHistory", getTransferDealerHistoryHandler)
}
function* watchCallToSendCustomerAssignDealerEmail() {
  yield takeEvery("queue/callToSendCustomerAssignDealerMail", sendCustomerAssignDealerEmail)
}
function* watchCallToGetReAssignMicroDetails() {
  yield takeEvery('queue/callToGetReAssignMicroHistory', getReAssignDealerMicroData);
}
function* watchCallToSaveTransferFilters() {
  yield takeEvery("queue/callToUpdateTransferDetails", updateTransferDetails)
}
function* watchCallToRemoveTransferFilters() {
  yield takeEvery("queue/callToRemoveTransferFilters", removeTransferFiltersFunction)
}
function* watchCallToGetTransferFilters() {
  yield takeEvery("queue/callToGetTransferFilters", getAppliedTransferFilters)
}
function* watchCallToGetPermissionsTabs() {
  yield takeEvery("queue/callToGetPermissionsTabsList", getPermissionsList);
}
function* watchCallToUpdatePermissionsTabs() {
  yield takeEvery("queue/callToUpdatePermissionsTabsList", updatePermissions);
}
function* watchCallToEcommerceStatus() {
  yield takeEvery('queue/callToGetEcommerceStatus', getECommerceStatus);
}

function* watchGetAutoCompleteApiResult() {
  yield takeEvery('queue/callToGetAutoCompleteApiResult', getAutoCompleteApiResult)
}

function* watchCallToGetReAssignDealerHistory() {
  yield takeEvery('queue/callToGetReAssignDealerHistory', onGetReAssignDealerHistory);
}

function* watchCallToGetDocumentStatus() {
  yield takeEvery('queue/callToGetDocumentStatus', onGetDocumentStatus);
}

function* watchCallToGetEmailTemplate() {
  yield takeEvery('queue/callToGetEmailTemplate', callToGetEmailTemplate);
}

function* watchCallToSkipStep() {
  yield takeEvery('queue/callToSkipStep', onSkipStep);
}
function* watchCallToGetLicenseRecordDetails() {
  yield takeEvery('queue/callToGetLicenseRecordDetails', onGetValidLicenseStatus);
}

export {
  watchCallToEZCheckValidator,
  watchcallToEZCheckForTransferCreation,
  watchcallToGetTransferStatusWorkFlow,
  watchCallToupdateTransferArchive,
  watchcallToDownloadTransferList,
  watchcallToGetStoreNames,
  watchcallToGetSourceDescriptions,
  watchCallInBoundTransferAction,
  watchcallToGetStoreFilterConfigData,
  watchCallToGetTransferDetails,
  watchCallToResendIinitiationEmail,
  watchCallToGenerateMasterProof,
  watchCallToAssignTransferDealerHandler,
  watchCallToAssignTransferLicenseHandler,
  watchcallToGetTransferDealerHistory,
  watchCallToSendCustomerAssignDealerEmail,
  watchCallToGetReAssignMicroDetails,
  watchCallToSaveTransferFilters,
  watchCallToRemoveTransferFilters,
  watchCallToGetTransferFilters,
  watchCallToGetReAssignDealerHistory,
  watchCallToGetPermissionsTabs,
  watchCallToUpdatePermissionsTabs,
  watchCallToEcommerceStatus,
  watchGetAutoCompleteApiResult,
  watchCallToGetDocumentStatus,
  watchCallToGetSellerDetails,
  watchCallToGetRecieverDetails,
  watchCallToSkipStep,
  watchCallToGetEmailTemplate,
  watchCallToGetLicenseRecordDetails,
  watchCallToGetTransferFilterCollection,
  watchCallToSaveTransferFilterCollection,
  watchCallToDeleteTransferFilterCollection
}
